export default __webpack_public_path__ + "static/media/edit-blog-icon.b669811a.svg";